import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow_left.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow_right.svg';
import PolicyScrollPopup, { PolicyDocumentBody } from '../../components/common/PolicyScrollPopup';
import { POLICY_TYPES, getPolicySections, getPolicyTitle } from '../../content/policies';

const PROCESSING_POLICY_URL = 'https://plip.kr/pcc/e72d3829-a44c-486a-963d-f027390015b1/privacy/2.html';

export default function PolicyPage() {
  const navigate = useNavigate();
  const [policyType, setPolicyType] = useState(null);

  return (
    <section className="policy-page">
      <div className="page-header header-shadow">
        <ArrowIcon onClick={() => navigate(-1)} style={{ left: 24 }} />
        <h3>약관 및 개인정보 처리 방침</h3>
      </div>

      <article className="policy-list">
        <button type="button" className="policy-list-item" onClick={() => setPolicyType(POLICY_TYPES.SERVICE)}>
          <p>서비스 이용 약관</p>
          <ArrowRight width={13} />
        </button>
        <button type="button" className="policy-list-item" onClick={() => setPolicyType(POLICY_TYPES.COLLECTION)}>
          <p>개인정보 수집 및 이용</p>
          <ArrowRight width={13} />
        </button>
        {/* <a href={PROCESSING_POLICY_URL} target="_blank" rel="noreferrer">
          <p>개인정보 처리방침</p>
          <ArrowRight width={13} />
        </a> */}
      </article>

      <PolicyScrollPopup open={!!policyType} type={policyType} onClose={() => setPolicyType(null)} />
    </section>
  );
}

export function AgreementDetail(props) {
  const navigate = useNavigate();
  const { type } = props;

  const getPageTitle = () => {
    switch (type) {
      case 'service':
        return getPolicyTitle(POLICY_TYPES.SERVICE) || '서비스 이용 약관';
      case 'collection':
        return getPolicyTitle(POLICY_TYPES.COLLECTION) || '개인정보 수집 및 이용';
      case 'processing':
        return '개인정보 처리방침';
      default:
        return '서비스 이용 약관';
    }
  };

  const getAgreementContent = () => {
    switch (type) {
      case 'service':
        return <PolicyDocumentBody sections={getPolicySections(POLICY_TYPES.SERVICE)} />;
      case 'collection':
        return <PolicyDocumentBody sections={getPolicySections(POLICY_TYPES.COLLECTION)} />;
      case 'processing':
        return (
          <p>
            개인정보 처리방침은{' '}
            <a href={PROCESSING_POLICY_URL} target="_blank" rel="noreferrer">
              여기에서
            </a>{' '}
            확인할 수 있습니다.
          </p>
        );
      default:
        return <PolicyDocumentBody sections={getPolicySections(POLICY_TYPES.SERVICE)} />;
    }
  };

  return (
    <section>
      <div className="page-header header-shadow">
        <ArrowIcon onClick={() => navigate(-1)} style={{ left: 24 }} />
        <h3>{getPageTitle()}</h3>
      </div>
      <article className="agreement-detail">
        <div>{getAgreementContent()}</div>
      </article>
    </section>
  );
}
